import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-card-horario-recebimento',
  templateUrl: './card-horario-recebimento.component.html',
  styleUrls: ['./card-horario-recebimento.component.css']
})
export class CardHorarioRecebimentoComponent implements OnChanges{

  @Input() abrevDia = '';
  @Input() recebe = false;
  @Input() horaDePrimeiro = null;
  @Input() horaAtePrimeiro = null;
  @Input() horaDeSegundo = null;
  @Input() horaAteSegundo = null;
  txtDia = '';

  ngOnChanges(): void {
    this.txtDia = this.getDiaSemana(this.abrevDia);
  }

  getDiaSemana(abreviado: string): string {
  switch (abreviado.toUpperCase()) {
    case "SEG":
      return "Segunda-feira";
    case "TER":
      return "Terça-feira";
    case "QUA":
      return "Quarta-feira";
    case "QUI":
      return "Quinta-feira";
    case "SEX":
      return "Sexta-feira";
    case "SAB":
      return "Sábado";
    case "DOM":
      return "Domingo";
    default:
      return "Dia inválido";
  }
}

}
